import axios from 'axios';
import { projects } from './mockProjects';

const jazzHrInstance = axios.create({
  baseURL: 'https://api.resumatorapi.com/v1/',
  params: { apikey: '4tWhJFtr8iWAl3VHxRc8HVIk0dSZEOBU' },
});

const apiInteresneeInstance = axios.create({
  baseURL: 'https://api.interesnee.ru',
});

/**
 * Get list of jobs.
 *
 * @return {[{board_code: string, city: sting,...}]} list of jobs
 */
export function fetchJobs() {
  return jazzHrInstance.get('jobs').then(response => response.data);
}

export function fetchHashToken() {
  return apiInteresneeInstance
    .get('/sign-form.php')
    .then(response => response.data.hash);
}

/**
 * Send information about the applicant to the API for save to file.
 *
 * @param {{firstname: string, lastname: string,...}[]} Applicant data
 * @return {array}
 */
export async function sendResume(params) {
  const data = new FormData();

  data.append('campCity', params.campCity);
  data.append('city', params.city);
  data.append('email', params.email);
  data.append('firstname', params.firstname);
  data.append('jobID', params.jobID);
  data.append('lastname', params.lastname);
  data.append('phone', params.phone);
  data.append('resumeFile', params.resumeFile);
  data.append('resumeFileName', params.resumeFileName);
  data.append('resumeText', params.resumeText);
  data.append('vacancy', params.vacancy);

  if (params.fromCampPage) {
    data.append('achievements', params.achievements);
    data.append('department', params.department);
    data.append('diploma', params.diploma);
    data.append('expectations', params.expectations);
    data.append('feedback', params.feedback);
    data.append('fromCampPage', params.fromCampPage);
    data.append('hobby', params.hobby);
    data.append('languages', params.languages);
    data.append('link', params.link);
    data.append('specialty', params.specialty);
    data.append('study', params.study);
    data.append('university', params.university);
    data.append('whereFind', params.whereFind);
    data.append('year', params.year);
  }

  fetchHashToken().then(hash => {
    data.append('hash', hash);

    return apiInteresneeInstance.post('/save-form.php', data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  });
}

/**
 * Send information about the promo to the API for save to file.
 *
 * @param {{firstname: string, lastname: string,...}[]} Applicant data
 * @return {array}
 */
export function sendPromo(params) {
  const data = new FormData();

  data.append('firstname', params.firstname);
  data.append('lastname', params.lastname);
  data.append('phone', params.phone);
  data.append('email', params.email);
  data.append('promoText', params.promoText);

  return apiInteresneeInstance
    .post('/save-promo.php', data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then(response => response);
}

function getProjectBySlug(slug, projects) {
  const current = slug => projects.filter(project => project.slug === slug)[0];

  const currentIndex = slug => projects.findIndex(obj => obj === current(slug));

  const prevIndex = slug =>
    currentIndex(slug) > 0 ? currentIndex(slug) - 1 : false;

  const nextIndex = slug =>
    currentIndex(slug) < projects.length - 1 ? currentIndex(slug) + 1 : false;

  const prev = slug =>
    prevIndex(slug) !== false && prevIndex(slug) >= 0
      ? projects[prevIndex(slug)].slug
      : false;
  const next = slug =>
    nextIndex(slug) ? projects[nextIndex(slug)].slug : false;

  return {
    current: current(slug) || null,
    prevSlug: prev(slug) || null,
    nextSlug: next(slug) || null,
  };
}

export function fetchProjectBySlug(slug) {
  const project = getProjectBySlug(slug, projects);
  if (project) {
    return Promise.resolve(project);
  }
  return Promise.reject(project);
}

export function sendSubscribe(email) {
  const data = new FormData();
  data.append('email', email);
  return apiInteresneeInstance
    .post('/subscribe.php', data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then(response => response);
}

/**
 * Get the most recent media from instagram.
 *
 * @return {{"data": []}} media data
 */
export function fetchInstagramRecentPost() {
  return apiInteresneeInstance
    .get('instagram-post.php')
    .then(response => response);
}

/**
 * change Open Graph tag
 * @param name og property name
 * @param value content value
 */
export function changeOgMeta(name, value) {
  document
    .querySelector(`meta[property="${name}"]`)
    .setAttribute('content', value);
}



// WEBPACK FOOTER //
// ./src/data/index.js